import { createAsyncThunk } from '@reduxjs/toolkit'
import { getMyBetsService, getTopBetsService } from 'games/BalloonPumpGame/balloonPumpGame.service'

const normalizeBets = (res) => {
  if (Array.isArray(res?.bets)) return res
  if (Array.isArray(res?.rows)) return { ...res, bets: res.rows }
  if (Array.isArray(res)) return { bets: res }
  return { bets: [] }
}

export const getMyBets = createAsyncThunk('balloon-pump-game/myBets', async (params = { limit: 10, offset: 0 }, thunkApi) => {
  try {
    const res = await getMyBetsService(params)
    return normalizeBets(res)
  } catch (error) {
    return thunkApi.rejectWithValue(error?.[0]?.description || error?.message)
  }
})

export const getTopBets = createAsyncThunk('balloon-pump-game/topBets', async (params = { limit: 10, offset: 0 }, thunkApi) => {
  try {
    const res = await getTopBetsService(params)
    return normalizeBets(res)
  } catch (error) {
    return thunkApi.rejectWithValue(error?.[0]?.description || error?.message)
  }
})
